module.exports = __webpack_public_path__ + "static/media/JUSTSans-Bold.1ae7fa1b.woff2";